import { Action, Dispatch } from 'redux'
import { closeStockModalAction } from 'reducks/modal/actions'

const closeStockModal = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(closeStockModalAction())
  }
}

export default closeStockModal
